// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/projects/v1/projects_service.proto (package protos.vision.projects.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { CreateVisionLocationRequestSchema, CreateVisionLocationResponseSchema } from "./create_vision_location_pb";
import { file_vision_projects_v1_create_vision_location } from "./create_vision_location_pb";
import type { CreateVisionProjectRequestSchema, CreateVisionProjectResponseSchema } from "./create_vision_project_pb";
import { file_vision_projects_v1_create_vision_project } from "./create_vision_project_pb";
import type { DeleteVisionLocationRequestSchema, DeleteVisionLocationResponseSchema } from "./delete_vision_location_pb";
import { file_vision_projects_v1_delete_vision_location } from "./delete_vision_location_pb";
import type { DeleteVisionProjectRequestSchema, DeleteVisionProjectResponseSchema } from "./delete_vision_project_pb";
import { file_vision_projects_v1_delete_vision_project } from "./delete_vision_project_pb";
import type { GetVisionProjectRequestSchema, GetVisionProjectResponseSchema } from "./get_vision_project_pb";
import { file_vision_projects_v1_get_vision_project } from "./get_vision_project_pb";
import type { ListMyVisionProjectsRequestSchema, ListMyVisionProjectsResponseSchema } from "./list_my_vision_projects_pb";
import { file_vision_projects_v1_list_my_vision_projects } from "./list_my_vision_projects_pb";
import type { ListVisionLocationsRequestSchema, ListVisionLocationsResponseSchema } from "./list_vision_locations_pb";
import { file_vision_projects_v1_list_vision_locations } from "./list_vision_locations_pb";
import type { TrackVisionPresenceRequestSchema, TrackVisionPresenceResponseSchema } from "./track_vision_presence_pb";
import { file_vision_projects_v1_track_vision_presence } from "./track_vision_presence_pb";
import type { UpdateVisionLocationRequestSchema, UpdateVisionLocationResponseSchema } from "./update_vision_location_pb";
import { file_vision_projects_v1_update_vision_location } from "./update_vision_location_pb";
import type { UpdateVisionBoardRulesRequestSchema, UpdateVisionBoardRulesResponseSchema } from "./update_vision_board_rules_pb";
import { file_vision_projects_v1_update_vision_board_rules } from "./update_vision_board_rules_pb";
import type { UpdateVisionProjectRequestSchema, UpdateVisionProjectResponseSchema } from "./update_vision_project_pb";
import { file_vision_projects_v1_update_vision_project } from "./update_vision_project_pb";

/**
 * Describes the file vision/projects/v1/projects_service.proto.
 */
export const file_vision_projects_v1_projects_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_vision_projects_v1_create_vision_location, file_vision_projects_v1_create_vision_project, file_vision_projects_v1_delete_vision_location, file_vision_projects_v1_delete_vision_project, file_vision_projects_v1_get_vision_project, file_vision_projects_v1_list_my_vision_projects, file_vision_projects_v1_list_vision_locations, file_vision_projects_v1_track_vision_presence, file_vision_projects_v1_update_vision_location, file_vision_projects_v1_update_vision_board_rules, file_vision_projects_v1_update_vision_project]);

/**
 * @generated from service protos.vision.projects.v1.VisionProjects
 */
export const VisionProjects: GenService<{
  /**
   * @generated from rpc protos.vision.projects.v1.VisionProjects.CreateVisionProject
   */
  createVisionProject: {
    methodKind: "unary";
    input: typeof CreateVisionProjectRequestSchema;
    output: typeof CreateVisionProjectResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.projects.v1.VisionProjects.UpdateVisionProject
   */
  updateVisionProject: {
    methodKind: "unary";
    input: typeof UpdateVisionProjectRequestSchema;
    output: typeof UpdateVisionProjectResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.projects.v1.VisionProjects.DeleteVisionProject
   */
  deleteVisionProject: {
    methodKind: "unary";
    input: typeof DeleteVisionProjectRequestSchema;
    output: typeof DeleteVisionProjectResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.projects.v1.VisionProjects.UpdateVisionBoardRules
   */
  updateVisionBoardRules: {
    methodKind: "unary";
    input: typeof UpdateVisionBoardRulesRequestSchema;
    output: typeof UpdateVisionBoardRulesResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.projects.v1.VisionProjects.GetVisionProject
   */
  getVisionProject: {
    methodKind: "unary";
    input: typeof GetVisionProjectRequestSchema;
    output: typeof GetVisionProjectResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.projects.v1.VisionProjects.ListMyVisionProjects
   */
  listMyVisionProjects: {
    methodKind: "unary";
    input: typeof ListMyVisionProjectsRequestSchema;
    output: typeof ListMyVisionProjectsResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.projects.v1.VisionProjects.ListVisionLocations
   */
  listVisionLocations: {
    methodKind: "unary";
    input: typeof ListVisionLocationsRequestSchema;
    output: typeof ListVisionLocationsResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.projects.v1.VisionProjects.CreateVisionLocation
   */
  createVisionLocation: {
    methodKind: "unary";
    input: typeof CreateVisionLocationRequestSchema;
    output: typeof CreateVisionLocationResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.projects.v1.VisionProjects.UpdateVisionLocation
   */
  updateVisionLocation: {
    methodKind: "unary";
    input: typeof UpdateVisionLocationRequestSchema;
    output: typeof UpdateVisionLocationResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.projects.v1.VisionProjects.DeleteVisionLocation
   */
  deleteVisionLocation: {
    methodKind: "unary";
    input: typeof DeleteVisionLocationRequestSchema;
    output: typeof DeleteVisionLocationResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.projects.v1.VisionProjects.TrackVisionPresence
   */
  trackVisionPresence: {
    methodKind: "unary";
    input: typeof TrackVisionPresenceRequestSchema;
    output: typeof TrackVisionPresenceResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_vision_projects_v1_projects_service, 0);

